import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import { SiteContentProvider } from './context/SiteContentContext.tsx';
import { AuthProvider } from './context/AuthContext.tsx';
import { ErrorBoundary } from './components/ErrorBoundary.tsx';
import './index.css';

// Silently ignore normal browser abort events (caused by page reloads, tab navigation, or canceled in-flight requests)
if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    const isAbort = 
      reason?.name === 'AbortError' ||
      reason?.code === 20 ||
      (typeof reason?.message === 'string' && (
        reason.message.includes('The user aborted a request') ||
        reason.message.includes('aborted') ||
        reason.message.includes('signal is aborted')
      ));

    if (isAbort) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  });

  window.addEventListener('error', (event) => {
    const message = event.message || '';
    if (
      message.includes('The user aborted a request') ||
      message.includes('AbortError') ||
      event.error?.name === 'AbortError'
    ) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <SiteContentProvider>
          <App />
        </SiteContentProvider>
      </AuthProvider>
    </ErrorBoundary>
  </StrictMode>,
);
